module.exports = __webpack_public_path__ + "static/img/banner-1.a5e6019f.png";